// Get Shopify Products
export const GET_SHOPIFY_PRODUCTS_REQUEST = 'GET_SHOPIFY_PRODUCTS_REQUEST';
export const GET_SHOPIFY_PRODUCTS_DONE = 'GET_SHOPIFY_PRODUCTS_DONE';
export const GET_SHOPIFY_PRODUCTS_FAILED = 'GET_SHOPIFY_PRODUCTS_FAILED';
export const GET_SHOPIFY_PRODUCTS_RESET = 'GET_SHOPIFY_PRODUCTS_RESET';

// Operations
export const SHOPIFY_PRODUCTS_SET_PAGE_URL = 'SHOPIFY_PRODUCTS_SET_PAGE_URL';
